import { createAsyncThunk } from "@reduxjs/toolkit";
import { getCustomers } from "../../services/customer";
import { getSalesVoucherNumber, savePharmaSales, editPharmaSales as editPharmaSalesService, editSales as editSalesService, saveSales } from "../../services/sales";
import { getBatchApi } from "../../apiservice/accounts";
import {
  getCustomerSpecialPriceApi,
  getCurrentStockApi,
  getAvailableTatmeenSerialCollection,
  getBatchSerialsApi,
} from "../../apiservice/sales";
import { getAccountByTypeApi, getAccountBySeachApi, getInsuranceCompany, getDoctorApi, getPatientApi } from "../../apiservice/setting";
import { getproductpackingstructure } from "../../apiservice/inventory";
// Thunk for fetching customer list
export const fetchCustomerList = createAsyncThunk(
  "salesPharma/fetchCustomerList",
  async (searchValue, { rejectWithValue }) => {
    try {
      const response = await getCustomers({
        query: searchValue.trim(),
        type: "debitor",
        acc_type_name: ["Customer", "patient"],
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

// Thunk for fetching sales voucher number and default account

export const fetchSalesVoucherNumber = createAsyncThunk(
  "salesPharma/fetchSalesVoucherNumber",
  async (val, { rejectWithValue }) => {
    try {
      const response = await Promise.all([
        getSalesVoucherNumber({ entryDate: val }),
        getCustomers({
          acc_name: "Cash",
          multiType: ["cash_in_hand"],
        }),
      ]);

      return {
        salesVoucherNumber: response[0].data,
        defaultAccount: response[1].data,
      };
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const createSales = createAsyncThunk(
  "salesPharma/createSales",
  async (payload, { rejectWithValue }) => {

    let response;
    try {
      if (payload?.masterData?.insurance_id && payload.insuranceData.insurance_id) {
        response = await savePharmaSales(payload);
      } else {
        response = await saveSales(payload);
      }

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const editPharmaSales = createAsyncThunk(
  "salesPharma/editPharmaSales",
  async (payload, { rejectWithValue }) => {

    let response;
    try {
      response = await editPharmaSalesService(payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);


export const fetchBatchesForItem = createAsyncThunk(
  "itemAdjustment/fetchBatchesForItem",
  async (payload) => {
    // const payload = {
    //   item_id: itemId,
    //   item_qty: 1,
    // };
    const res = await getBatchApi(payload);
    const formattedData = (res.data || []).map((b) => ({
      id: b.id,
      batch_name: b.batch_name,
      batch_expiry: b.batch_expiry,
      quantity: b.quantity,
      serial_mode: b.serial_mode,
    }));

    return formattedData;
  }
);

// ✅ Keep this — correct one
export const fetchPackingStructureForItem = createAsyncThunk(
  "salesPharma/fetchPackingStructureForItem",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await getproductpackingstructure(payload);

      // Check if we have data
      if (!res.data?.data || res.data.data.length === 0) {
        return [];
      }

      // Get the first item (since API returns array with one object)
      const item = res.data.data[0];

      // Create array of all packing levels
      const packingLevels = [
        { name: item.std_pack_name, qty: item.std_pack_qty, rate: item.std_rate },
        { name: item.second_pack_name, qty: item.second_pack_qty, rate: item.second_rate },
        { name: item.third_pack_name, qty: item.third_pack_qty, rate: item.third_rate },
        { name: item.fourth_pack_name, qty: item.fourth_pack_qty, rate: item.fourth_rate },
        { name: item.fifth_pack_name, qty: item.fifth_pack_qty, rate: item.fifth_rate },
        { name: item.sixth_pack_name, qty: item.sixth_pack_qty, rate: item.sixth_rate },
      ];

      // Filter out empty/null packing names
      const formattedData = packingLevels.filter(
        (pack) => pack.name && pack.name !== "N/A" && pack.qty
      );

      return formattedData || [];
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);


export const fetchSpecialPrices = createAsyncThunk(
  "salesPharma/fetchSpecialPrices",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await getCustomerSpecialPriceApi(payload);
      return response.data || [];
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const fetchDiscountAccounts = createAsyncThunk(
  "supplierPayments/fetchDiscountAccounts",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getAccountByTypeApi({
        acc_name: "discount on sale",
        acc_type_id: "direct_expense",
      });
      return res.data[0];
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const fetchTaxAccounts = createAsyncThunk(
  "supplierPayments/fetchTaxAccounts",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getAccountByTypeApi({
        acc_type_id: "dutie_&_tax",
      });
      return res.data[0];
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const fetchTransportAccounts = createAsyncThunk(
  "supplierPayments/fetchTransportAccounts",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getAccountByTypeApi({
        acc_type_id: "direct_income",
      });
      return res.data[0];
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const fetchSalesAccounts = createAsyncThunk(
  "supplierPayments/fetchSalesAccounts",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getAccountBySeachApi({
        multiType: ["sale_account"],
      });
      return res.data[0];
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const fetchCurrentStock = createAsyncThunk(
  "supplierPayments/fetchCurrentStock",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await getCurrentStockApi(payload);
      return res.data[0];
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);


export const fetchPatients = createAsyncThunk(
  "salesPharma/fetchPatients",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getPatientApi({});
      // expecting res.data.data (based on your earlier examples)
      return res.data?.data || [];
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);


export const fetchDoctors = createAsyncThunk(
  "salesPharma/fetchDoctors",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getDoctorApi({});
      return res.data?.data || [];
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const fetchInsuranceCompanies = createAsyncThunk(
  "salesPharma/fetchInsuranceCompanies",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getInsuranceCompany({});
      return res.data?.data || [];
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const fetchAvailableTatmeenSerials =
  createAsyncThunk(
    "sales/fetchAvailableSerials",
    async (payload) => {

      const res = await getBatchSerialsApi(payload);

      return res.data || [];
    }
  );



